import React from 'react';
import LobbyChat from '../Core/LobbyChat';
import JoinedPlayers from '../Core/JoinedPlayers';
import RoomDetails from './RoomDetails';
import { gameStateManager } from '../../App';

export default class RoomSetup extends React.Component
{
  state = {
    gameStateData: null,
  };

  onGameStateChangedCallbackHandle = null;

  componentDidMount()
  {
    this.onGameStateChangedCallbackHandle = ( gameStateData ) =>
    {
      this.setState( { gameStateData: gameStateData } );
    };

    gameStateManager.onGameStateChangedRegister( this.onGameStateChangedCallbackHandle );
  }

  componentWillUnmount()
  {
    gameStateManager.onGameStateChangedUnregister( this.onGameStateChangedCallbackHandle );

    this.onGameStateChangedCallbackHandle = null;
  }

  render()
  {
    const {
      gameStateData
    } = this.state;

    const clientSocketID = gameStateManager.socketClientID;
    const playersInRoom = gameStateData && gameStateData.playerData ? gameStateData.playerData.playersJoined : [];
    const isRoomHost = playersInRoom && playersInRoom.length > 0 && clientSocketID === playersInRoom[ 0 ].socketID;

    let thisPlayerData = null;
    for( let idx = 0; idx < playersInRoom.length; idx++ )
    {
      if( clientSocketID === playersInRoom[ idx ].socketID )
      {
        thisPlayerData = playersInRoom[ idx ];
        break;
      }
    }
    const thisPlayerMarkedAsReady = thisPlayerData != null ? thisPlayerData.isReady : false;
    const areAllPlayersReady = playersInRoom && playersInRoom.every( player => player.isReady === true || player === thisPlayerData );

    return (
      <>
        <div className="left-page-panel">
          <JoinedPlayers
            playersInRoom={ playersInRoom }
            clientId={ clientSocketID }
            isRoomHost={ isRoomHost }
            maxPlayers={ gameStateManager.socketRoomOptions.maxPlayersLimit }
          />
        </div>
        <div className="middle-page-panel">
          <RoomDetails
            roomID={ gameStateManager.socketConnectedRoomId }
            isRoomHost={ isRoomHost }
            areAllPlayersReady={ areAllPlayersReady }
            options={ gameStateManager.socketRoomOptions }
            isPlayerReady={ thisPlayerMarkedAsReady }
          />
        </div>
        <div className="right-page-panel">
          <LobbyChat />
        </div>
      </>
    );
  }
}
